import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ['checkbox-group'];
  static targets = ['toggled'];

  toggle() {
    const checkedCount = this.checkboxGroupOutlet.followerTargets.filter(checkbox => checkbox.checked).length;
    this.toggledTarget.classList.toggle('hidden', checkedCount === 0);
  }
}
